import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Inject,
	OnDestroy,
	OnInit,
	Optional,
	ViewChild,
	ViewContainerRef,
	ViewEncapsulation,
} from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { DialogStatusAction } from "@obg/ngx.core";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { MAT_CORE_CONFIG } from "../const";
import { MatCoreConfig } from "../model";

import { ALERT_DIALOG_ID } from "./alert.const";
import { AlertButton, AlertButtonStyle, AlertConfig, AlertOptions } from "./alert.model";

@Component({
	selector: "obg-m-alert",
	templateUrl: "./alert.component.html",
	styleUrls: ["./alert.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class AlertComponent implements OnInit, AfterViewInit, OnDestroy {
	@HostBinding("class.obg-m-alert") cssHostClass = true;

	@ViewChild("message", { read: ViewContainerRef }) set messagePlaceholder(value: ViewContainerRef | undefined) {
		if (!value || !this.data.messageComponent) {
			return;
		}

		const factory = this.factoryService.get(this.data.messageComponent);
		const ref = value.createComponent(factory);
		if (this.data.messageComponentInit) {
			this.data.messageComponentInit(ref.instance);
		}

		ref.changeDetectorRef.markForCheck();
		this.changeDetector.detectChanges();
	}

	dialogId: string;
	transparentButton = AlertButtonStyle.Transparent;
	strokedButton = AlertButtonStyle.Stroked;
	doNotShowAgain = false;

	private config: AlertConfig;
	private dialogRef: MatDialogRef<any> | undefined;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AlertOptions,
		@Optional() @Inject(MAT_CORE_CONFIG) coreConfig: MatCoreConfig,
		protected factoryService: ComponentFactoryService,
		protected changeDetector: ChangeDetectorRef,
		protected dialog: MatDialog,
		protected dialogStatusAction: DialogStatusAction,
		// TODO remove store related code in scope of https://jirasson.betsson.local/browse/OSBFE-1395
		protected store: Store
	) {
		this.config = coreConfig?.alert || {};
		this.dialogId = this.data.id || ALERT_DIALOG_ID;
		this.store.dispatch(this.dialogStatusAction.open());
	}

	ngOnInit() {
		if (!this.data.buttons || !this.data.buttons.length) {
			return;
		}

		this.dialogRef = this.dialog.getDialogById(this.dialogId);
		if (!this.dialogRef) {
			return;
		}

		for (const button of this.data.buttons) {
			const handler = button.handler;
			button.style = button.style || this.config.defaultButtonStyle;

			button.handler = () => {
				let result;
				if (handler) {
					result = handler({ doNotShowAgain: this.doNotShowAgain });
				}

				this.dialogRef?.close(result);
			};
		}
	}

	ngAfterViewInit() {
		if (!this.data.messageComponent || !this.messagePlaceholder) {
			return;
		}
		const factory = this.factoryService.get(this.data.messageComponent);
		this.messagePlaceholder.createComponent(factory);
		this.changeDetector.markForCheck();
	}

	ngOnDestroy() {
		this.store.dispatch(this.dialogStatusAction.close());
	}

	onElementClick(element: HTMLElement) {
		if (element.tagName.toLowerCase() === "a" && this.data.dialogConfig?.closeOnNavigation) {
			this.dialogRef?.close();
		}
	}

	trackByButton(_index: number, button: AlertButton) {
		return button.text;
	}

	getButtonColor(button: AlertButton) {
		return button.color || this.config.defaultButtonColor || "accent";
	}
}
